import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for RequestSolvedRow component customisation
 * Returns highlighted content section styling and content
 */
export const useRequestSolvedCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.HOME,
    sectionKey: PUI.HOME_SECTION_KEYS.CONTENT_SETTINGS,
    blockKey: PUI.HOME_BLOCK_KEYS.HIGHLIGHTED_CONTENT,
  });

  const labelText = getField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const labelColor = getField(PUI.COMMON_FIELD_KEYS.LABEL_COLOR);
  const subTextColor = getField(PUI.COMMON_FIELD_KEYS.SUB_TEXT_COLOR);
  const actionText = getField(PUI.COMMON_FIELD_KEYS.ACTION_TEXT);
  const actionColor = getField(PUI.COMMON_FIELD_KEYS.ACTION_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);

  return {
    isVisible,
    labelText,
    labelColor,
    subTextColor,
    actionText,
    actionColor,
    backgroundColor,
  };
};
